import { kelas } from '../action-types';

const initialState = {
  data: [],
  isFetching: false,
  dataJenjang: [],
  isFetchingJenjang: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case kelas.FETCH_JENJANG:
      return {
        ...state,
        isFetchingJenjang: true,
      };
    case kelas.FETCH_KELAS:
      return {
        ...state,
        isFetching: true,
      };
    case kelas.GET_KELAS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    case kelas.GET_JENJANG:
      return {
        ...state,
        isFetchingJenjang: false,
        dataJenjang: action.payload,
      };
    default:
      return state;
  }
};
